import { PromotionSearchForm } from './PromotionSearchForm'
import { withPromotionSearchForm } from './withPromotionSearchForm'

const ConnectedPromotionSearchForm =
  withPromotionSearchForm(PromotionSearchForm)

export { ConnectedPromotionSearchForm as PromotionSearchForm }
